import { Box, FlexBox, Modal, ModalHead } from '@dixa/lib-shared-habla';
import { useModal } from 'lib-knowledge-modal';

import { Suggestion } from '../utils/toSuggestion';

import { ArticleComparison } from './articleComparison';
import s from './articleComparisonModal.module.scss';

type ArticleComparisonModalProps = {
  suggestion: Suggestion;
};

/**
 * The comparison in a window of its own.
 *
 * Built on habla's `Modal` rather than `ModalWrapper`. The wrapper's only
 * addition is `width: 600px` and the two panels need far more, so going
 * straight to `Modal` — which sets no width of its own — makes the width here a
 * plain declaration instead of a fight over specificity. `ModalBody` is skipped
 * for the same reason: its only style is a `spacer-500` margin, and the panels
 * are meant to reach the modal's edges.
 */
export function ArticleComparisonModal({
  suggestion,
}: ArticleComparisonModalProps): JSX.Element {
  const { hideModal } = useModal();

  return (
    <Modal isOpen onClose={hideModal} className={s.modal}>
      {/* `title` takes a node, so centring it needs no reach into ModalHead's
          own styles. It centres within the title column, which stops short of
          the close button — a hair left of the modal's true centre. */}
      <ModalHead
        title={<Box align="center">Article Comparison</Box>}
        onClose={hideModal}
      />

      <FlexBox flexDirection="column" className={s.body}>
        <ArticleComparison suggestion={suggestion} />
      </FlexBox>
    </Modal>
  );
}
